// Imports
import { createSelector } from 'reselect';
import getOrdering from './getOrdering';

export default createSelector([getOrdering], ordering => {
  const { enableAdvancedCustomHours } = ordering.config;

  return enableAdvancedCustomHours;
});
